module.exports = __webpack_public_path__ + "img/register-eye-close.afd8e7f5.svg";